import { useMemo } from "react";
import _ from "lodash";

import theme from "theme";
import { colors } from "theme/palette";
import { fieldOptionRetrieve } from "utils/common";

import Stack from "components/Stack";
import Tag from "components/Tag";
import Text from "components/Text";

import PrintableFieldTitle from "pages/PrintableChecklist/components/PrintableFieldTitle";

import { EFieldStatus } from "entities/Field/constants";
import { IField } from "entities/Field/sdk";

export interface IPrintableRadiobuttonfield {
  field: IField;
}

const PrintableRadiobuttonfield = ({ field }: IPrintableRadiobuttonfield) => {
  const value = useMemo(
    () =>
      fieldOptionRetrieve({
        options: field.options,
        value: _.get(field.custom_values, "[0].selected_value"),
      }),
    [field.custom_values, field.options]
  );

  return (
    <Stack
      id={field.field_id.toString()}
      direction="row"
      justifyContent="space-between"
      alignItems="flex-start"
      spacing={2}
      sx={{
        padding: theme.spacing(0.5),
        borderBottom: `1px solid ${colors.blue20}`,
        backgroundColor: "initial",
      }}
      data-testid="dd-field"
    >
      <PrintableFieldTitle field={field} />
      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        maxWidth="40%"
        paddingTop={0.5}
      >
        {field.status === EFieldStatus.NA ? (
          <Text sx={{ color: colors.gray60 }}>N/A</Text>
        ) : (
          <>
            {!value && <Tag label="missing" variant="red" />}
            {value && <Text variant="text2">{value.label}</Text>}
          </>
        )}
      </Stack>
    </Stack>
  );
};

export default PrintableRadiobuttonfield;
